export enum ALERT_TYPES {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info"
}
